'use strict';

export enum Language {
  English = 'English',
  Spanish = 'Español',
}
